<div class="mb-3 grid grid-cols-1 gap-3 md:grid-cols-2">
  <ui-form-field label="Code" [required]="true" [for]="idPrefix() + '-code'" class="mb-0!">
    <input
      uiInput
      size="sm"
      type="text"
      [id]="idPrefix() + '-code'"
      [ngModel]="value().code"
      (ngModelChange)="patch({ code: $event })"
      [disabled]="disabled() || codeReadOnly()"
      placeholder="e.g. PAWAPAY_CD"
    />
  </ui-form-field>
  <ui-form-field label="Name" [required]="true" [for]="idPrefix() + '-name'" class="mb-0!">
    <input
      uiInput
      size="sm"
      type="text"
      [id]="idPrefix() + '-name'"
      [ngModel]="value().name"
      (ngModelChange)="patch({ name: $event })"
      [disabled]="disabled()"
      placeholder="e.g. PawaPay Congo"
    />
  </ui-form-field>
</div>

<div class="mb-3 grid grid-cols-1 gap-3 md:grid-cols-2">
  <ui-form-field label="Provider Type" [for]="idPrefix() + '-type'" class="mb-0!">
    <select
      uiInput
      size="sm"
      [id]="idPrefix() + '-type'"
      [ngModel]="value().provider_type"
      (ngModelChange)="patch({ provider_type: $event })"
      [disabled]="disabled()"
    >
      @for (pt of providerTypes; track pt.value) {
        <option [value]="pt.value">{{ pt.label }}</option>
      }
    </select>
  </ui-form-field>
  @if (showAdapter()) {
    <ui-form-field label="Adapter Class" [for]="idPrefix() + '-adapter'" class="mb-0!">
      <input
        uiInput
        size="sm"
        type="text"
        [id]="idPrefix() + '-adapter'"
        [ngModel]="value().adapter_class"
        (ngModelChange)="patch({ adapter_class: $event })"
        [disabled]="disabled()"
        placeholder="e.g. PawaPay"
      />
    </ui-form-field>
  }
</div>

<div class="mb-3 grid grid-cols-1 gap-3 md:grid-cols-2">
  <ui-form-field label="Financial Entity" class="relative mb-0!">
    <div class="relative">
      <input
        uiInput
        size="sm"
        type="text"
        placeholder="Search entities..."
        [ngModel]="search().entity"
        (ngModelChange)="setSearch('entity', $event)"
        (focus)="open.set('entity')"
        [disabled]="disabled()"
      />
      @if (value().financial_entity && !disabled()) {
        <button type="button" class="absolute top-1/2 right-2 -translate-y-1/2 cursor-pointer border-0 bg-transparent p-0 leading-none text-muted hover:text-danger" (click)="clear('entity')">
          <ng-icon name="lucideX" size="12" />
        </button>
      }
    </div>
    @if (open() === 'entity' && filteredEntities().length > 0) {
      <div class="absolute top-full right-0 left-0 z-1100 max-h-[200px] overflow-y-auto rounded-b-md border border-border bg-card shadow-lg">
        @for (opt of filteredEntities(); track opt.id) {
          <div class="flex cursor-pointer items-baseline gap-2 px-2.5 py-2 text-[0.78rem] transition-colors hover:bg-row-hover" (mousedown)="select('entity', opt)">
            <span class="font-mono text-[0.78rem] font-semibold">{{ opt.code }}</span>
            <span class="text-[0.72rem] text-muted">{{ opt.name }}</span>
          </div>
        }
      </div>
    }
  </ui-form-field>

  <ui-form-field label="Country" class="relative mb-0!">
    <div class="relative">
      <input
        uiInput
        size="sm"
        type="text"
        placeholder="Search countries..."
        [ngModel]="search().country"
        (ngModelChange)="setSearch('country', $event)"
        (focus)="open.set('country')"
        [disabled]="disabled()"
      />
      @if (value().country && !disabled()) {
        <button type="button" class="absolute top-1/2 right-2 -translate-y-1/2 cursor-pointer border-0 bg-transparent p-0 leading-none text-muted hover:text-danger" (click)="clear('country')">
          <ng-icon name="lucideX" size="12" />
        </button>
      }
    </div>
    @if (open() === 'country' && filteredCountries().length > 0) {
      <div class="absolute top-full right-0 left-0 z-1100 max-h-[200px] overflow-y-auto rounded-b-md border border-border bg-card shadow-lg">
        @for (opt of filteredCountries(); track opt.id) {
          <div class="flex cursor-pointer items-baseline gap-2 px-2.5 py-2 text-[0.78rem] transition-colors hover:bg-row-hover" (mousedown)="select('country', opt)">
            <span class="font-mono text-[0.78rem] font-semibold">{{ opt.code }}</span>
            <span class="text-[0.72rem] text-muted">{{ opt.name }}</span>
          </div>
        }
      </div>
    }
  </ui-form-field>

</div>

<div class="mb-3 grid grid-cols-1 gap-3 md:grid-cols-2">
  <ui-form-field label="Currency" class="relative mb-0!">
    <div class="relative">
      <input
        uiInput
        size="sm"
        type="text"
        placeholder="Search currencies..."
        [ngModel]="search().currency"
        (ngModelChange)="setSearch('currency', $event)"
        (focus)="open.set('currency')"
        [disabled]="disabled()"
      />
      @if (value().currency && !disabled()) {
        <button type="button" class="absolute top-1/2 right-2 -translate-y-1/2 cursor-pointer border-0 bg-transparent p-0 leading-none text-muted hover:text-danger" (click)="clear('currency')">
          <ng-icon name="lucideX" size="12" />
        </button>
      }
    </div>
    @if (open() === 'currency' && filteredCurrencies().length > 0) {
      <div class="absolute top-full right-0 left-0 z-1100 max-h-[200px] overflow-y-auto rounded-b-md border border-border bg-card shadow-lg">
        @for (opt of filteredCurrencies(); track opt.id) {
          <div class="flex cursor-pointer items-baseline gap-2 px-2.5 py-2 text-[0.78rem] transition-colors hover:bg-row-hover" (mousedown)="select('currency', opt)">
            <span class="font-mono text-[0.78rem] font-semibold">{{ opt.code }}</span>
            <span class="text-[0.72rem] text-muted">{{ opt.name }}</span>
          </div>
        }
      </div>
    }
  </ui-form-field>

  @if (showActive()) {
    <div class="flex items-end">
      <label class="inline-flex cursor-pointer items-center gap-2 text-sm text-fg" [for]="idPrefix() + '-active'">
        <input
          class="size-4 accent-primary"
          type="checkbox"
          [id]="idPrefix() + '-active'"
          [ngModel]="value().is_active"
          (ngModelChange)="patch({ is_active: $event })"
          [disabled]="disabled()"
        />
        Active
      </label>
    </div>
  }
</div>
